import {Calendar, MapPin, PartyPopper} from "lucide-react";
import profilePhotoBackground from "../../assets/celebrations/profilephotoBackground.png";

interface BirthdayProfileCardProps {
    name: string;
    jobTitle: string;
    location: string;
    celebrationDate: string;
    photoUrl?: string;
}

const BirthdayProfileCard = ({ name, jobTitle, location, celebrationDate, photoUrl }: BirthdayProfileCardProps) => {
    return (
        <div className="w-full h-full">

            {/* Birthday Badge */}
            <div className="flex justify-center mb-2">
                <div className="bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-semibold shadow-lg">
                    🎂 Birthday
                </div>
            </div>

            {/* Profile Background */}
            <div className="relative rounded-2xl overflow-hidden mb-4">

                {/* Stars Background */}
                <img
                    src={profilePhotoBackground}
                    alt="Birthday Background"
                    className="w-full h-[350px] object-cover rounded-2xl"
                />

                {/* Employee Photo */}
                {photoUrl && (
                    <div className="absolute inset-0 flex items-center justify-center">
                        <img
                            src={photoUrl}
                            alt={name}
                            className="w-48 h-48 rounded-full object-cover border-4 border-white/30 shadow-2xl"
                        />
                    </div>
                )}

            </div>

            {/* Employee Details */}
            <h2 className="text-4xl font-bold text-white">
                {name}
            </h2>

            <p className="text-lg text-gray-300 mt-1">
                {jobTitle}
            </p>

            {/* Location + Date */}
            <div className="flex gap-3 mt-4">

                <div className="flex-1 bg-blue-800/40 rounded-xl p-3 flex items-center gap-2">
                    <MapPin className="w-5 h-5 text-purple-400"/>
                    <span>{location}</span>
                </div>

                <div className="flex-1 bg-blue-800/40 rounded-xl p-3 flex items-center gap-2">
                    <Calendar className="w-5 h-5 text-purple-400"/>
                    <span>{celebrationDate}</span>
                </div>

            </div>

            {/* Celebration Type */}
            <div className="bg-blue-800/40 rounded-xl p-4 mt-4 flex items-center gap-3">

                <div
                    className="
                        w-12 h-12
                        rounded-full
                        bg-gradient-to-br
                        from-fuchsia-600
                        to-purple-700
                        flex
                        items-center
                        justify-center

                    "
                >
                    <PartyPopper className="w-6 h-6 text-white"/>
                </div>

                <div>
                    <p className="text-gray-400 text-sm">
                        Celebration Type
                    </p>

                    <p className="text-yellow-300 font-semibold text-base">
                        Birthday Celebration Today 🎉
                    </p>
                </div>

            </div>

        </div>
    );
};

export default BirthdayProfileCard;